import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/_dashboard/analytics/$codebaseId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/analytics/$codebaseId/$tab',
      params: { organizationName: params.organizationName, codebaseId: params.codebaseId, tab: 'overview' },
    });
  },
});
